import Controller from "csi/action/Controller";
import JsonResponse from "csi/comm/JsonResponse";
import PostRequest from "csi/comm/PostRequest";
import locale from "csi/locale";
import session from "csi/session";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const ViewProofController = declare(Controller, {

	/**
	 * @override
	 * Navigate to the latest ProofWorkFlow of current revision of a document
	 */
	postProcessSuccess() {
		const node = this.getNode();
		let workflowUrl = "";
		if (node.$Type == "ProofWorkflowInstance") {
			workflowUrl = node.$URL;
		} else {
			const proofStageCnl = node.__Parent__;
			workflowUrl = this.m_cache.getNode(proofStageCnl).__Parent__;
		}
		if (!xml.isEmptyURL(workflowUrl)) {
			const postRequest = new PostRequest("Proofing", "IsProofMember", {
				Workflow: workflowUrl,
			});

			postRequest.go()
				.then((data: JsonResponse) => {
					if (data.getReturnValue()) {
						session.setLocationUrl(workflowUrl, true);
					} else {
						this.displayErrorDialog({ message: locale.resource("NoPermissionToViewProof") });
					}
				});
		}
	},
});

export = ViewProofController;